<template>       
    <div class="clearfix company-form-container rounded mt-4 pb-5 mx-auto pl-3 pr-3">    
        <div class="clearfix row py-2 mb-2 border-bottom">       
            <div class="col-sm-2 px-3 company-form-box-title">Resources</div> 
            <div class="col-sm-8 custom-search ">                
                <b-input-group class="mb-0">
                    <b-input-group-prepend is-text>
                        <b-icon icon="search"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                </b-input-group>
            </div>
            <div class="col-sm-2 float-right text-right pr-0">                
                
            </div>
        </div> 

        
        <div class="justify-content-center">
            <b-overlay :show="showoverlay_list" rounded="sm">
                <table class="table list-tables"> 
                    <thead>
                        <tr class="table-head">
                            <td>Name</td>
                            <td>Title</td>
                            <td>Required Full Access</td>
                            <td>Need Approval</td>
                            <td>Group</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="hover-bg table-row border-bottom mx-2" v-for="(resource , n) in paginatedData" :key="resource.id">
                            <td class="col-md-5 align-middle list-columns">{{resource.name}}</td>  
                            <td class="col-md-5 align-middle list-columns">{{resource.title}}</td>
                            <td class="col-md-5 align-middle list-columns">{{ access_types[resource.full_access].text }}</td> 
                            <td class="col-md-5 align-middle list-columns">{{ approval[resource.need_approval].text }}</td> 
                            <td class="col-md-5 align-middle list-columns">{{ groups[resource.group_id] }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav></div>
            
            
            
            </b-overlay>
            
        </div>
        
    </div>
</template>


<script>
    export default{
        
        mounted() {
            
        },
        data(){            
            
            return {                
                
                resources:[],
                showoverlay:false,
                showoverlay_list:false,

                access_types: [                    
                    { value: "0", text: "No" },
                    { value: "1", text: "Yes" },
                    { value: "2", text: "Read Only" },
                ],
                approval: [                    
                    { value: "0", text: "No" },
                    { value: "1", text: "Yes" },
                ],

                groups : [],

                
                
                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},

                ce : false,
            }
        },
        methods:{
            
            
            addNew(x)
            {
                this.addtype = x;
                this.resetForm();
                this.$bvModal.show('bv-modal-role');
                
            },
            getResourceList: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/acl/resource/list' , {
                    params: {
                        
                    }
                }).then(function(response){

                    console.log(response.data);
                    this.resources = response.data;                    

                }.bind(this)).catch(function (error){
                    //currentObj.serverError(error);
                    });
            },
            getResourceGroups: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/acl/resource/groups' , {
                    params: {
                        
                    }
                }).then(function(response){
                    this.groups = response.data;                    

                }.bind(this)).catch(function (error){
                    currentObj.serverError(error);
                });
            },

        },
        created: function(){
            this.getResourceList();
            this.getResourceGroups();
            Fire.$on('reloadUsers', () => {this.getResourceList()});
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.resources;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>